<template>
  <div class="comment">
    <div class="comment-heading columns">
      <div
        class="column is-12 card-header has-text-centered"
        @click="switchTournaments()"
      >
        <strong
          class="card-user-name"
          :class="{active: tournaments}"
        >Tournaments</strong>
      </div>
    </div>
    <div v-if="tournaments">
      <div class="comment-heading columns">
        <div class="column is-12 has-text-centered">
          <div
            class="dropdown is-fullwidth"
            :class="{'is-active': dropdownTournaments}"
            @click="showTournaments()"
          >
            <div class="dropdown-trigger is-fullwidth">
              <button
                class="button is-fullwidth"
                aria-haspopup="true"
                aria-controls="dropdown-menu"
              >
                <span>{{ getMonth(selectedMonth) }}</span>
                <span class="icon is-small">
                  <i
                    class="far fa-angle-down"
                    aria-hidden="true"
                  />
                </span>
              </button>
            </div>
            <div
              class="dropdown-menu is-fullwidth"
              role="menu"
            >
              <div class="dropdown-content">
                <a
                  class="navbar-item"
                  @click="selectMonth(0)"
                >{{ getMonth(getCurrentMonth()) }}</a>
                <a
                  class="navbar-item"
                  @click="selectMonth(-1)"
                >{{ getMonth(getCurrentMonth() - 1) }}</a>
                <a
                  class="navbar-item"
                  @click="selectMonth(-2)"
                >{{ getMonth(getCurrentMonth() - 2) }}</a>
                <a
                  class="navbar-item"
                  @click="selectMonth(-3)"
                >{{ getMonth(getCurrentMonth() - 3) }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!game.recentTournaments.length"
        class="has-text-centered"
        style="padding: .5rem;"
      >
        There are no records for this month
      </div>
      <div
        v-if="game.recentTournaments.length"
        class="comment-heading columns is-flex"
      >
        <div
          class="column is-3 has-text-centered-touch"
          style="order: 1;"
        >
          <strong class="is-size-7-touch">Date</strong>
        </div>
        <div
          class="column is-6 has-text-centered-touch"
          style="order: 2;"
        >
          <strong class="is-size-7-touch">Winner</strong>
        </div>
        <div
          class="column is-3 has-text-centered-touch"
          style="order: 3;"
        >
          <strong class="is-size-7-touch" />
        </div>
      </div>
      <div
        v-for="tournament in game.recentTournaments"
        class="comment-block columns is-flex"
      >
        <div
          class="column is-3 has-text-centered-touch"
          style="order: 1;"
        >
          <small class="is-size-7-touch">{{ tournament.tournDate }}</small>
        </div>
        <div
          class="column is-6 has-text-centered-touch"
          style="order: 2;"
        >
          <router-link
            class="is-size-7-touch"
            :to="{path: `/players/${tournament.ahlid}`}"
          >
            {{ tournament.winner }}
          </router-link>
        </div>
        <div
          class="column is-3 has-text-centered-touch"
          style="order: 3;"
        >
          <router-link
            class="is-size-7-touch"
            :to="{path: `/tournaments/${tournament.tournid}`}"
          >
            [Details]
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['game', 'selectedMonth'],
    data () {
      return {
        tournaments: false,
        dropdownTournaments: false
      }
    },
    methods: {
      getMonth (number) {
        // Number is month 0 - Jan, 1 - Feb, etc. If current month is Nov or Dec turn to Jun and Feb
        if (number === 12) number = 0
        if (number === 13) number = 1
        if (number === -1) number = 11
        if (number === -2) number = 10
        if (number === -3) number = 9
        switch (number) {
          case 0:
            return 'January'
          case 1:
            return 'February'
          case 2:
            return 'March'
          case 3:
            return 'April'
          case 4:
            return 'May'
          case 5:
            return 'June'
          case 6:
            return 'July'
          case 7:
            return 'August'
          case 8:
            return 'September'
          case 9:
            return 'October'
          case 10:
            return 'November'
          case 11:
            return 'December'
          default:
            return 'Error'
        }
      },
      showTournaments () {
        this.dropdownTournaments = !this.dropdownTournaments
      },
      selectMonth (number) {
        this.$emit('setMonth', number, 10)
      },
      getCurrentMonth () {
        let date = new Date()
        return date.getMonth()
      },
      switchTournaments () {
        this.tournaments = !this.tournaments
      }
    }
  }
</script>
